import React from "react";
import "./LogoNav.scss";

const LogoButtonsNav = () => {
  return (
    <nav className = "logo-nav">
      <span className="logo">Bowtie</span>
    </nav>
  );
};

export default LogoButtonsNav;
